import React from "react";
import "./HomeFeaturesSection.css";
import { Row, Col } from "react-bootstrap";
import chat from "../../../img/featuresicons/chat.svg";
import test from "../../../img/featuresicons/test.svg";
import blog from "../../../img/featuresicons/blog.svg";
// import forums from "../../../img/featuresicons/forums.svg";

function Features() {
  return (
    <div className="features-wrapper">
      <Row className='justify-content-center'>
        <Col xs={6} lg={3}>
          <div className="feature-card">
            <div className="feature-image">
              <img src={chat} alt="First slide" />
            </div>
            <div className="feature-text">
              <p>Chat online with trusted peers</p>
            </div>
          </div>
        </Col>
        <Col xs={6} lg={3}>
          <div className="feature-card">
            <div className="feature-image">
              <img src={test} alt="Second slide" />
            </div>
            <div className="feature-text">
              <p>Evaluate yourself through quizzes</p>
            </div>
          </div>
        </Col>
        <Col xs={6} lg={3}>
          <div className="feature-card">
            <div className="feature-image">
              <img src={blog} alt="Third slide" />
            </div>
            <div className="feature-text">
              <p>Browse blogs written by fellow authors</p>
            </div>
          </div>
        </Col>
        {/* <Col xs={6} lg={3}>
          <div className="feature-card">
            <div className="feature-image" style={{ filter: "blur(10px)" }}>
              <img src={forums} alt="Third slide" />
            </div>
            <div className="feature-text" style={{ filter: "blur(10px)" }}>
              <p>Be a part of the community through our forums</p>
            </div>
          </div>
        </Col> */}
      </Row>
    </div>
  );
}

export { Features };
